import {AlpineComponent} from 'alpinejs';

type LanguageSuggestionLoaderData = {
  init(): Promise<void>;
}

// A plain fetch, deliberately not alpine-ajax's $ajax() magic: that helper dispatches
// ajax:before/ajax:after on window whenever the triggering element (this placeholder) ends up
// disconnected, which it always does here (self-removing or self-replacing). FormJs and SolrSearch
// both listen for that same window event to scroll their own element into view after a real
// form/search interaction, so a silent background fetch through $ajax() was triggering an
// unrelated scroll-into-view on any page that also had a form or search widget.
export default (): AlpineComponent<LanguageSuggestionLoaderData> => ({
  async init() {
    const uri = this.$el.dataset.uri;
    if (!uri) {
      return;
    }

    const response = await fetch(uri);
    if (!response.ok) {
      return;
    }

    const fragment = document.createRange().createContextualFragment(await response.text());
    const content = fragment.getElementById('language-suggestion');

    if (content) {
      this.$el.replaceWith(content);
    } else {
      this.$el.remove();
    }
  }
});
